import { Descriptions } from 'antd';
import StatusTag from '../../../../components/ui/StatusTag';
import { ReceivingReportRecord } from '../../../../types/ReceivingReport';
import React from 'react';

interface ReceivingReportInfoViewProps {
  data: ReceivingReportRecord | undefined;
}
const ReceivingReportInfoView: React.FC<ReceivingReportInfoViewProps> = ({
  data,
}) => {
  return (
    <>
      <Descriptions
        title="Receiving Report"
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '0.25rem',
        }}
      >
        <Descriptions.Item label="Code">{data?.code}</Descriptions.Item>
        <Descriptions.Item label="Required Date">
          {data?.requiredDate}
        </Descriptions.Item>
        <Descriptions.Item label="Date Received">
          {data?.receivedDate}
        </Descriptions.Item>
        <Descriptions.Item label="Destination Location">
          {data?.destination?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Vendor">
          {data?.vendor?.description}
        </Descriptions.Item>
        <Descriptions.Item label="RR Purpose">
          {data?.rrPurpose}
        </Descriptions.Item>
        <Descriptions.Item label="Invoice No.">
          {data?.invoiceNo}
        </Descriptions.Item>
        <Descriptions.Item label="DR No.">{data?.drNo}</Descriptions.Item>
        <Descriptions.Item label="Source Document">
          {data?.source}
        </Descriptions.Item>
        <Descriptions.Item label="Currency">{data?.currency}</Descriptions.Item>
        <Descriptions.Item label="Withholding Tax">
          {data?.wtax}
        </Descriptions.Item>
        <Descriptions.Item label="VAT">{data?.vat}</Descriptions.Item>
        <Descriptions.Item label="Discount">{data?.discount}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag status={data?.status ?? ''} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default ReceivingReportInfoView;
